import { Descriptions, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { type SdmModuleSpecsFragment } from '../../../../../api/fragments/SdmModuleSpecs';
import AuthorizationEmpty from './AuthorizationEmpty';

export type AuthorizationProps = {
    module: SdmModuleSpecsFragment;
};

const Authorization = ({ module }: AuthorizationProps) => {
    const { t } = useTranslation('sdmModuleDetails');

    if (!module.authorization) {
        return <AuthorizationEmpty module={module} />;
    }

    return (
        <Card>
            <Descriptions column={{ xs: 1, md: 2 }} bordered>
                <Descriptions.Item label={t('sdmModuleDetails:fields.authorization.accessKey.label')}>
                    {module.authorization.accessKey}
                </Descriptions.Item>
                <Descriptions.Item label={t('sdmModuleDetails:fields.authorization.secretKey.label')}>
                    {module.authorization.secretKey}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default Authorization;
